import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import Box from "@mui/material/Box";
import axios from "../../../../utils/fvAxios";
import BaseURL from "../../../../utils/base-uri.json";
import { useEffect } from "react";

function UnpinAllButton({
  pqId,
  onSaveMessage,
  messageData,
  isPinned,
  onUnpinAllMessages,
  unPinTitle,
}) {
  useEffect(() => {}, [unPinTitle]);

  const unpinAllClickHandler = () => {
    (async () => {
      const data = await axios.post(
        BaseURL.baseUrl + BaseURL.widget.UnpinAllMessages + "pqId=" + pqId
      );
      if (data.data.responseMessage === "Success") {
        onUnpinAllMessages(data.data.data);
      }
    })();
  };
  return (
    <Box
      px={3}
      py={2}
      style={{ position: "absolute", bottom: 0, width: "100%" }}
      className="border-top txt-clr-blue1 text-center cursor-pointer "
      onClick={unpinAllClickHandler}
    >
      <PushPinOutlinedIcon />
      <span>Unpin {unPinTitle}</span>
    </Box>
  );
}

export default UnpinAllButton;
